import React from 'react';

interface DialogProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  message: string;
  type?: 'success' | 'error' | 'info';
}

const Dialog: React.FC<DialogProps> = ({ isOpen, onClose, title, message, type = 'info' }) => {
  if (!isOpen) return null;

  const getTypeStyles = () => {
    switch (type) {
      case 'success':
        return {
          backgroundColor: '#d1fae5',
          borderColor: '#10b981',
          titleColor: '#065f46',
          messageColor: '#047857'
        };
      case 'error':
        return {
          backgroundColor: '#fee2e2',
          borderColor: '#ef4444',
          titleColor: '#7f1d1d',
          messageColor: '#dc2626'
        };
      default:
        return {
          backgroundColor: '#dbeafe',
          borderColor: '#3b82f6',
          titleColor: '#1e3a8a',
          messageColor: '#1d4ed8'
        };
    }
  };

  const typeStyles = getTypeStyles();

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 1000,
      }}
      onClick={onClose}
    >
      <div
        style={{
          backgroundColor: 'white',
          borderRadius: '12px',
          padding: '24px',
          maxWidth: '400px',
          width: '90%',
          boxShadow: '0 10px 25px rgba(0, 0, 0, 0.1)',
          border: `2px solid ${typeStyles.borderColor}`,
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div
          style={{
            padding: '12px',
            backgroundColor: typeStyles.backgroundColor,
            borderRadius: '8px',
            marginBottom: '16px',
            border: `1px solid ${typeStyles.borderColor}`,
          }}
        >
          <h3
            style={{
              margin: '0 0 8px 0',
              fontSize: '18px',
              fontWeight: '600',
              color: typeStyles.titleColor,
            }}
          >
            {title}
          </h3>
          <p
            style={{
              margin: 0,
              fontSize: '14px',
              color: typeStyles.messageColor,
              lineHeight: '1.5',
            }}
          >
            {message}
          </p>
        </div>
        <div style={{ textAlign: 'right' }}>
          <button
            onClick={onClose}
            style={{
              backgroundColor: '#3b82f6',
              color: 'white',
              border: 'none',
              borderRadius: '6px',
              padding: '8px 16px',
              fontSize: '14px',
              fontWeight: '500',
              cursor: 'pointer',
              transition: 'background-color 0.2s ease',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = '#2563eb';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = '#3b82f6';
            }}
          >
            OK
          </button>
        </div>
      </div>
    </div>
  );
};

export default Dialog; 